// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VimFz5ib9l9gOo {
  max-width: 600px;
  margin: 0 auto;
  padding: 32px;
}
.DFOeG5Ntwxh_b3 {
  padding: 8px 0;
}
.PdqyVPaVcbFnJ_ {
  display: flex;
}
.C7CMkr6ZI6FGfM {
  flex: 1;
}
.yBZGBNQq9GkbFh {
  margin-left: 8px;
  white-space: nowrap;
}
.uMAHP0_Zisyaex {
  display: flex;
}
.mRcnhSKkQ74Tni {
  margin-right: 4px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `VimFz5ib9l9gOo`,
	"pageDescription": `DFOeG5Ntwxh_b3`,
	"pageHeaderContainer": `PdqyVPaVcbFnJ_`,
	"pageHeader": `C7CMkr6ZI6FGfM`,
	"pageHeaderActions": `yBZGBNQq9GkbFh`,
	"pageInfoContainer": `uMAHP0_Zisyaex`,
	"pageInfoIcon": `mRcnhSKkQ74Tni`
};
export default ___CSS_LOADER_EXPORT___;
